<template>
  <div class="py-8" v-if="loading">
    <loading />
  </div>
  <div class="h-full" v-else>
    <div class="py-2">
      <wd-filter
        :filters="filters"
        :input-array="users"
        @update="filteredUsers = $event"
      />
    </div>
    <div v-if="users && users.length > 0">
      <user v-for="user in filteredUsers" :key="user.id" :user="user" />
      <load-more-section show-count show-page name="user" @input="getUsers" />
    </div>
    <div class="h-full p-8 stack grid content-center" v-else>
      <span class="text-gray-800 leading-snug">{{
        $t("users.no_users_yet")
      }}</span>
    </div>
  </div>
</template>

<script>
const User = require("@/modules/users/components/User.vue").default;

import FormMixin from "@/mixins/FormMixin";
import { User as UserModel } from "@/modules/users/viewmodels/User";
const LoadMoreSection = require("@/modules/core/components/LoadMoreSection.vue")
  .default;
const WdFilter = require("@/modules/core/components/WdFilter.vue").default;

export default {
  name: "UsersSite",
  mixins: [FormMixin],
  data() {
    return {
      users: [],
      filteredUsers: [],
      roles: [],
      filters: [],
      userResult: null,
      usersLoading: false,
    };
  },
  props: {
    select: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Array,
    },
  },
  components: {
    User,
    LoadMoreSection,
    WdFilter,
  },
  methods: {
    emitClose() {
      this.$emit("close");
    },
    async getUsers() {
      this.users = await this.getEntity("user");
    },
  },
  computed: {},
  async created() {
    await this.getUsers();

    this.formOptions = {
      custom: true,
      async: true,
      type: "users",
      call: "search",
      action: (response) => {
        this.searchResult = response;
      },
    };

    this.filters.push(
      {
        name: this.$t("users.username"),
        key: "username",
        input: "text",
      }
    );

    if (this.permissionCheck('roles-all')){
      this.roles = await this.$store.getters["roles/api"].GetAll();
      this.filters.push(
      {
        name: this.$t("users.role"),
        key: "roles",
        input: "select",
        type: "includes",
        options: this.roles,
        optionId: "name",
        optionLabel: "name",
      });
    }

    this.loaded();
  },
};
</script>
